module.exports = __webpack_public_path__ + "img/info-icon.c6069bea.svg";